import React from 'react'
import styled from 'styled-components'

const Styles = {
    HoverCard: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: ${({width}) => width };

    padding: ${({padding}) => padding}; 
    border: 0.2rem dashed ${({borderColor}) => borderColor};
    border-radius: ${({theme}) => theme.borderRadius};
    box-shadow: 0 3px 15px ${({ shadowColor }) => shadowColor}40;
    margin: 1rem;
    background-color: ${({ bgColor }) => bgColor};
    &:hover {
      opacity: 0.9;
      transform: scale(0.98);
  }
    `,
}

const FloatButton = ({borderColor='grey', shadowColor = '#000000', bgColor='#ffffff',padding='1rem 2rem', width = '100%', handleClick, children}) => {
  return (
   <Styles.HoverCard onClick={handleClick} width={width} shadowColor={shadowColor} bgColor={bgColor} padding={padding} borderColor={borderColor}
   > 
       {children}
   </Styles.HoverCard>
  )
}

export default FloatButton


